import { getByIdWorkoutSectionSelector } from '@gymaholic/packages'
import Button from 'components/Button'
import Text from 'components/Text'
import { View } from 'components/View'
import { getStartWorkoutSelector } from 'modules/training/modules/training-start-workout/selectors'
import PlusButton from 'pages/Workout/components/PlusButton'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import getNameReduxUtil from 'modules/redux/utils/get-name'
import { getPaddingHorizontalWorkoutSelect } from 'pages/Workout/redux/selectors/get-padding-horizontal/index.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen/index.js'

/**
 * @param id
 * @param index
 * @param style
 * @param handleClickWorkoutSection
 * @param workoutSections
 * @param handleClickCreateWorkoutSection
 * @param needsPremium
 * @returns {JSX.Element}
 * @constructor
 */
const WorkoutSection = ({
  id,
  index,
  style,
  handleClickWorkoutSection,
  workoutSections,
  handleClickCreateWorkoutSection
}) => {
  const workoutSection = useSelector(getByIdWorkoutSectionSelector(id))
  const startWorkout = useSelector(getStartWorkoutSelector())
  const isLast = index === workoutSections.length
  const paddingHorizontal = useSelector(getPaddingHorizontalWorkoutSelect)
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)

  if (
    isLast &&
    !handleClickCreateWorkoutSection
  ) {
    return <></>
  }

  if (
    index === workoutSections.length &&
    handleClickCreateWorkoutSection
  ) {
    return (
      <View
        style={style}
        ml={isSmallScreen ? 1 : 0}
      >
        <PlusButton
          width='103px'
          onClick={handleClickCreateWorkoutSection}
        />
      </View>
    )
  }

  const handleClick = () => handleClickWorkoutSection(index, workoutSection)

  return (
    <View
      pl={isSmallScreen ? paddingHorizontal : 0}
      style={style}
    >
      <Button
        onClick={handleClick}
        style={{
          width: 'unset',
          height: 'unset',
          maxWidth: 'unset'
        }}
      >
        <View
          w='103px'
          px='4px'
          centered
          py='8px'
          bgc={
            startWorkout.currentWorkoutSectionIndex === index
              ? '#151D21'
              : '#ffffff'
          }
          style={{
            boxSizing: 'border-box',
            borderRadius: '6px',
            border: startWorkout.currentWorkoutSectionIndex === index
              ? '1px solid #151D21'
              : '1px solid #DDDDDD'
          }}
        >
          <Text
            numberOfLines={1}
            c={
              startWorkout.currentWorkoutSectionIndex === index
                ? '#ffffff'
                : '#7F8D94'
            }
            fw='500'
            fs='13px'
          >
            {getNameReduxUtil(workoutSection)}
          </Text>
        </View>
      </Button>
    </View>
  )
}

export default WorkoutSection
